<template>
  <div class="container" :style="'background-color: rgba(251, 251, 251, 1);'">
    <!-- 头部 -->
    <AHeader :data="deductionDetail" />
    <!-- 考评信息 -->
    <AAssessInfo :data="deductionDetail" />

    <!-- 相关材料 -->
    <div class="pg-pd12" v-if="assessFileNOtype.length > 0 || inveDetailList.length > 0">
      <template v-if="monitorType === 'A1' ">
        <materialScience v-if="monitorType === 'A1' && assessFileNOtype.length > 0" :caseList="assessFileNOtype"
          title="相关材料"></materialScience>
        <!-- <materialScienceSpan v-if="monitorType === 'A2'" :caseList="assessFileNOtype" title="相关材料">
        </materialScienceSpan> -->
      </template>

      <!-- a2  a3 查处情况 -->
      <template v-else>
        <investigateDetail @addbtnClick="addbtnClicka" @delFile="clickDelFileA3" @updataConfirm="updataConfirm"
          :hasDetail="hasinvestidetail" :inveDetailList="inveDetailList" :addAuth="addAuth" :year="year"
          :quarter="quarter" :deleteAuth="deleteAuth" :updateAuth="updateAuth" :submitAuth="submitAuth"
          :isSubmited="deductionDetail.submited" :datauserId="deductionDetail.lastUpdaterId"></investigateDetail>
      </template>

    </div>
    <!-- 相关材料 暂无数据-->
    <div class="mx-12" v-else>
      <div class=" mt-24 mb-12 text-[#333333] text-16 font-500">
        相关材料
      </div>
      <div class="card-bg flex justify-center items-center">
          <span> 暂无数据</span>
      </div>
    </div>
  </div>
</template>
<script>
import causeDeduction from "../components/causeDeduction"; // 扣分原因
import materialScience from "./components/materialScience"; // 相关材料
import materialScienceSpan from "./components/materialScience_span";
import investigateDetail from "./components/investigateDetail"; //查处情况
import AHeader from './components/AHeader.vue'
import AAssessInfo from './components/AAssessInfo.vue'

import txtTag from "../components/txt-tag";
import addBtn from "./components/addBtn"; // 新增附件按钮
import scrollpicker from "./components/scrollPicker";
import commonPicker from "../../../components/base/myCommonPicker";

import RankChartsRate from "../components/RankChartsRate"; // 进度
import api from "../../../service/modules/appraise";
import apimessage from "../../../service/modules/message";
import apis from "../../../service/modules/index";
import apicomplaint from "../../../service/modules/complaint";
import util from "../../../utils/common";

import API from "../../../service/index";
import commonAPI from "../../../utils/common";
import cusBtn2 from "./components/cusBtn2";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";

import btnauth from "./components/btnauth";

import comfirmDialog from "./components/confirmDialog";
import updateBtn from './components/updateBtn';

import nodata from "../components/nodata.vue"; // 没有数据

import { type } from "os";
// Vue.use(Picker);
export default {
  components: {
    causeDeduction,
    materialScience,
    materialScienceSpan,
    txtTag,
    RankChartsRate,
    addBtn,
    scrollpicker,
    commonPicker,
    investigateDetail,
    cusBtn2,
    btnauth,
    comfirmDialog,
    updateBtn,
    AHeader,
    AAssessInfo,
    nodata
  },

  data() {
    return {
      isShowAuthdiglog: false,
      hasinvestidetail: false,
      inveDetailList: [],
      areaType: 1,
      assessFileNOtype: [],
      assessFilehasType: [],
      // 扣分原因
      deductionReason: "",
      isShow: true,
      // quarterName: this.$route.query.quarterName,
      newQuarterList: [
        [
          { id: "1", text: "人员到位情况" },
          { id: "2", text: "分发、转办事项落实情况" },
          { id: "3", text: "重大涉旅信息报送情况" },
          { id: "4", text: "工作制度情况" },
        ],
      ],
      cols1: 1,
      title: "",
      deductionDetail: {},
      userAuthoirese: "", //审核权限
      addAuth: "", // 新增权限
      deleteAuth: "", //删除权限
      updateAuth: "", // 编辑
      submitAuth: "", // 上报权限
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      area: this.$route.query.area,
      monitorType: this.$route.query.monitorType
        ? this.$route.query.monitorType
        : "A1",
      subName: this.$route.query.subName,
      decutionID: "",
      userId: commonAPI.getUserId(),
    };
  },

  computed: {
    totalScore() {
      if (this.monitorType === "A1") {
        return 1;
      } else if (this.monitorType === "A2") {
        return 2;
      } else if (this.monitorType === "A3") {
        return 3;
      }
    },
    deScore() {
      //   console.log("----总分:", this.totalScore);
      //   console.log("----扣的分:", this.deductionDetail.deduction);
      return (
        this.totalScore -
        (this.deductionDetail.deduction || 0) / 100
      ).toFixed(2);
    },
  },

  watch: {},

  created() {
    // const childAuth = commonAPI.getAuthorityList("ASSESS_SCORE");
    // const notifyobj = commonAPI.getChileAuthList(childAuth, "MENU01"); //综合监管
    // let temValue = "";
    // if (this.monitorType === "A1") {
    //   temValue = "MENU0101";
    // } else if (this.monitorType === "A2") {
    //   temValue = "MENU0102";
    // } else if (this.monitorType === "A3") {
    //   temValue = "MENU0103";
    // }
    // console.log('------对象:', notifyobj);
    // const childObj = commonAPI.getChildAuthListToChild(notifyobj, temValue);
    // console.log('-----子权限数组：',childObj );
    // if (childObj && childObj.length > 0) {
    //   this.userAuthoirese = "";
    //   this.addBtn = "";
    //   this.updateAuth = "";
    //   this.deleteAuth = "";
    //   this.submitAuth = "";
    //   for (let i = 0; i < childObj.length; i++) {
    //     // console.log('-------这里呢:', childObj[i]);
    //     if (childObj[i].value === "OPERATION06") {
    //       //审核权限
    //       this.userAuthoirese = "OPERATION06";
    //     }
    //     if (childObj[i].value === "OPERATION01") {
    //       // 新增
    //       // console.log('---不可能亚：',childObj[i].value);
    //       this.addAuth = "OPERATION01";
    //     }
    //     if (childObj[i].value === "OPERATION02") {
    //       //编辑
    //       this.updateAuth = "OPERATION02";
    //     }
    //     if (childObj[i].value === "OPERATION03") {
    //       //删除
    //       this.deleteAuth = "OPERATION03";
    //     }
    //     if (childObj[i].value === "OPERATION04") {
    //       //上报
    //       this.submitAuth = "OPERATION04";
    //     }
    //   }
    // }
    // const params = commonAPI.getJsonLocal("a1a2a3");
    // // console.log('-----获取参数:', params);
    // if (params) {
    // 	this.year = params.year;
    // 	this.quarter = params.quarter;
    // 	this.area = params.area;
    // 	this.monitorType = params.monitorType;
    // 	this.subName = params.subName;
    // }
    // this.getFileKind();
    // this.checkA1A2A3();


    if (this.monitorType === "A1") {
        this.featchA1CategoryData();
      } else {
        this.featchA2A4CategoryData();
      }
  },
  methods: {
    confirmAutchdialog() {
      // 跳审核 页面
      this.$router.push({
        path: "/appraise/autiting",
        query: { monitorType: this.monitorType, id: this.decutionID },
      });
    },
    checkbackDialog() {
      API.checkAuthBack({ id: this.decutionID }).then((res) => {
        console.log("----查看退回接口返回值:", res);
        if (res.ret == 0) {
          this.$Toast({
            message: "退回成功",
            icon,
          });
          this.checkA1A2A3();
          this.isShowAuthdiglog = false;
        } else {
          this.$Toast.fail("保存失败");
        }
      });
    },
    cancelDialog() {
      this.isShowAuthdiglog = false;
    },
    updateFileVOsClick() {
      // 编辑附件----需要从父级 将附件全部带到下一个页面
      // this.deductionDetail.fileResVOS
      this.$router.push({
        path: '/appraise/update_enclosure', query: {
          fields: this.assessFileNOtype,
          monitorType: this.monitorType,
          year: this.year,
          quarter: this.quarter,
          area: this.area,
          id: this.decutionID
        }
      });
    },
    getFileKind() {
      API.getFileKind({}).then((res) => {
        console.log("----附件类型:", res);
        if (res.ret == 0) {
          let temarr = [];
          this.newQuarterList = [];
          if (res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].code !== "common") {
                let obj = {
                  code: res.data[i].code,
                  text: res.data[i].desc,
                  desc: res.data[i].desc,
                };
                temarr.push(obj);
              }
            }
            this.newQuarterList.push(temarr);
          }
        }
      });
    },
    checkA1A2A3() {
      if (this.monitorType === "A1" || this.monitorType === "A2") {
        API.getDetailByA1A2({
          monitorType: this.monitorType,
          area: this.area,
          quarter: this.quarter,
          year: this.year,
        }).then((res) => {
          console.log("----A1A2:", res);
          if (res.ret == 0 && res.data) {
            this.deductionDetail = res.data;
            this.decutionID = res.data.id;
            if (res.data.fileResVOS && res.data.fileResVOS.length > 0) {
              this.assessFileNOtype = res.data.fileResVOS;
            }
          }
        });
      } else if (this.monitorType === "A3") {
        API.getDetailByA3({
          monitorType: this.monitorType,
          area: this.area,
          quarter: this.quarter,
          year: this.year,
        }).then((res) => {
          console.log("----A3详情:", res);
          if (res.ret == 0) {
            this.deductionDetail = res.data;
            this.decutionID = res.data.id;

            if (
              res.data.areaTripCaseDetailVO &&
              res.data.areaTripCaseDetailVO.length > 0
            ) {
              this.hasinvestidetail = true;
              this.inveDetailList = res.data.areaTripCaseDetailVO;
            } else {
              this.hasinvestidetail = false;
            }
          }
        });
      }
    },
    featchA1CategoryData() {
      API.getDetailByACategory({
        monitorType: this.monitorType,
        area: this.area,
        quarter: this.quarter,
        year: this.year,
      }).then((res) => {
        console.log("----A1:", res);
        if (res.ret == 0 && res.data) {
          this.deductionDetail = res.data;
          this.decutionID = res.data.id;
          if (res.data.fileResVOS && res.data.fileResVOS.length > 0) {
            this.assessFileNOtype = res.data.fileResVOS;
          }
        }
      });
    },
    featchA2A4CategoryData() {
      API.getDetailByA3({
        monitorType: this.monitorType,
        area: this.area,
        quarter: this.quarter,
        year: this.year,
      }).then((res) => {
        console.log("----A2A4:", res);
        if (res.ret == 0) {
            this.deductionDetail = res.data;
            this.decutionID = res.data.id;

            if (
              res.data.areaTripCaseDetailVO &&
              res.data.areaTripCaseDetailVO.length > 0
            ) {
              this.hasinvestidetail = true;
              this.inveDetailList = res.data.areaTripCaseDetailVO;
            } else {
              this.hasinvestidetail = false;
            }
          }
      });
    },
    authingClick() {
      if (this.monitorType == "A1") {
        // 跳审核 页面
        this.$router.push({
          path: "/appraise/autiting",
          query: { monitorType: this.monitorType, id: this.decutionID },
        });
      } else {
        this.isShowAuthdiglog = true;
      }
    },
    //新增附件
    addbtnClick() {
      this.$refs.commonPickerQuarter.showPicker();
    },
    // getTypeValue(value) {
    //   // this.$router.push({ path: "/appraise/add_enclosure", query: {} });
    // },
    //新增情况
    addbtnClicka(code) {
      if (typeof code === "object") {
        this.$router.push({
          path: "/appraise/travel_cases",
          query: {
            ...this.$route.query,
          },
        });
      } else {
        this.$router.push({
          path: "/appraise/travel_cases",
          query: {
            ...this.$route.query,
            code: code,
          },
        });
      }
    },
    /**
     * @description: A3 附件删除
     * @param {element} Object 需要删除的元素
     */
    async clickDelFileA3(element) {
      const res = await API.delFileByLawCaseA3({
        batchCode: element.areaTripCaseVO.batchCode,
        fileId: element.areaTripCaseVO.id,
        id: this.deductionDetail.id,
        monitorType: this.monitorType,
      });
      if (res.ret === 0) {
        this.$Toast({
          message: "保存成功",
          icon,
        });
        this.checkA1A2A3();
      }
    },
    /**
     * @description: A3 上报
     */
    async updataConfirm() {
      const res = await API.submitFiel({
        monitorType: this.monitorType,
        area: this.area,
        quarter: this.quarter,
        year: this.year,
        userId: commonAPI.getJsonLocal("appraiseNewLocalauthority").userId,
        msgId: "",
        typeCode: "1", // 1 是催办
      });
      if (res.ret === 0) {
        this.$Toast({
          message: "保存成功",
          icon,
        });
        setTimeout(() => {
          // 跳转到列表 页面
          this.$router.back(
            {
              path: "/appraise/deduction_list",
              query: {
                area: this.area,
                year: this.year,
                quarter: this.quarter,
                assessName: "综合监管模式完善运行情况",
              },
            },
            1000
          );
        });
      }
    },
  },
  beforeDestroy() { },
  mounted() { },
};
</script>
<style scoped lang="less">
@vv: 3.75vw;

.card-bg {
  background-color: #fff;
  padding-top: 16px;
  padding-bottom: 16px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  padding-left: 12px;
  padding-right: 12px;
}

.container {
  min-height: 100vh;
  background: rgba(251, 251, 251, 1);
  // background-color: #fff;
  padding-bottom: 70px;
  box-sizing: border-box;

  .pg-pd11 {
    padding-left: 12px;
    padding-right: 12px;
    position: relative;
  }

  .pg-pd11::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #eeeeee;
    overflow: hidden;
    //  transform: scaleY(0.5);
  }

  .pg-pd10 {
    box-sizing: border-box;
    width: 100%;
    background-color: white;

    .pd10div {
      padding-left: 12px;
      padding-right: 12px;
    }
  }

  .pg-pd12 {
    padding-left: 12px;
    padding-right: 12px;
  }

  .pg-pd13 {
    padding: 0 12px;
    text-align: center;

    span {
      display: inline-block;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      margin-top: 12px;
    }
  }

  .complain {
    position: relative;
    line-height: 46px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding: 0 16px;
    margin-top: 24px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }

  .complain::after {
    content: "";
    position: absolute;
    right: 16px;
    top: 16px;
    width: 12px;
    height: 12px;
    background: url(../../../assets/image/t-right.png) no-repeat;
    background-size: 12px 12px;
  }

  .head {
    width: 100%;
    background: #fff;
    padding: 23px 12px 12px 12px;
    border-bottom: 1px solid #eee;

    .title {
      line-height: 20px;
      display: flex;
      justify-content: space-between;
      min-height: 42.98px;

      .righttext {
        text-align: right;
      }

      .isaudied {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 140, 25, 1);
        line-height: 28px;
      }

      .text {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
        padding-right: 50px;
      }

      .score-div {
        font-size: 14px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;
        margin-top: 8px;
      }

      .branch {
        height: 22px;
        font-size: 22px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(255, 77, 77, 1);
        line-height: 28px;
      }

      .no-de {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(54, 179, 116, 1);
        line-height: 22px;
      }
    }

    .tag-box {
      width: 120%;
      height: 28px;
      display: flex;
      align-items: center;
      // margin-top: 10px;
      transform: scale(0.5);
      transform-origin: left 0;
      margin-top: -2px;
    }

    .date {
      margin-bottom: 4px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 12px;
    }
  }

  .main {
    margin-top: 24px;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }

    .content {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      margin-top: 12px;

      .pro-mr {
        margin-top: 24px;
        padding: 12px;
      }

      .tongji {
        display: flex;
        align-items: center;

        .tj-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          padding: 16px 0;
          text-align: center;

          .name {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }

          .num {
            font-size: 20px;
            font-family: DIN-Bold, DIN;
            font-weight: bold;
            color: rgba(54, 179, 116, 1);
            margin-top: 8px;
            vertical-align: top;
            display: inline-block;
            text-align: center;
            position: relative;

            span {
              font-size: 10px;
              padding-left: 4px;
              font-weight: normal;
              position: absolute;
              display: inline-block;
              font-weight: normal;
              bottom: 2px;
            }
          }
        }
      }

      .mt015 {
        margin-top: -15px;
      }

      .ts-list {
        width: 100%;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
        position: relative;
        vertical-align: top;
        display: inline-block;
        text-align: center;
        line-height: 41px;

        .img {
          position: absolute;
          display: inline-block;
          width: 10px;
          height: 10px;
          top: 50%;
          transform: translateY(-50.5%);

          img {
            width: 100%;
          }
        }
      }
    }
  }

  .bottom-examine {
    width: 100%;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
    position: fixed;
    bottom: 0;
    padding: 10px 12px;
  }

  .deduct_reason {
    padding: 15px 0 20px;
    background-color: #fff;
    position: relative;

    .deduct_tite {
      padding-bottom: 12px;
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }

    .deduct_cont {
      color: #333;
      font-size: 14px;
      line-height: 20px;
    }
  }

  // .deduct_reason::after{
  //    content: "";
  //    position: absolute;
  //    bottom: 0;
  //    left: 0;
  //    width: 100%;
  //    height: 1px;
  //    background-color: #eeeeee;
  //    overflow: hidden;
  //    transform: scaleY(0.5);
  // }
}
</style>
